<template>
  <main>
    <h1><u>Panneau d'administration d'<i>AVAP</i></u></h1>
    <section>
      <h2>Bienvenu(e) sur <span>AVAP</span> !</h2>
      <p>Voici quelques liens pour vous aider à démarrer :</p>
      <nav class="d-flex flex-row flex-wrap justify-content-between">
        <article class="mt-3">
          <router-link to="acheteurs" tag="section">
            <div>
              <font-awesome-icon size="4x" :icon="['fas', 'people-arrows']"></font-awesome-icon>
              <font-awesome-icon size="4x" :icon="['fas', 'people-arrows']"></font-awesome-icon>
            </div>
          </router-link>
          <router-link to="acheteurs" tag="section" class="d-flex flex-row justify-content-between">
            <div>&nbsp;</div>
            <div>Acheteurs</div>
            <div>100</div>
          </router-link>
        </article>
        <article class="mt-3">
          <router-link to="actualites" tag="section">
            <div>
              <font-awesome-icon size="4x" :icon="['fas', 'newspaper']"></font-awesome-icon>
            </div>
          </router-link>
          <router-link to="actualites" tag="section" class="d-flex flex-row justify-content-between">
            <div>&nbsp;</div>
            <div>Actualités</div>
            <div>200</div>
          </router-link>
        </article>
        <article class="mt-3">
          <router-link to="administrateurs" tag="section">
            <div>
              <font-awesome-icon size="4x" :icon="['fas', 'user-cog']"></font-awesome-icon>
            </div>
          </router-link>
          <router-link to="administrateurs" tag="section" class="d-flex flex-row justify-content-between">
            <div>&nbsp;</div>
            <div>Administrateurs</div>
            <div>2</div>
          </router-link>
        </article>
        <article class="mt-3">
          <section>
            <div v-if="!menus.menuOpen4">
              <font-awesome-icon size="4x" :icon="['fas', 'people-carry']"></font-awesome-icon>
              <font-awesome-icon size="4x" :icon="['fas', 'people-carry']"></font-awesome-icon>
            </div>
            <div v-if="menus.menuOpen4">
              <div>
                <font-awesome-icon :icon="['fas', 'truck-loading']"></font-awesome-icon>
                <router-link to="livreurs">Livreurs</router-link>
              </div>
              <div>
                <font-awesome-icon :icon="['fas', 'person-booth']"></font-awesome-icon>
                <router-link to="receptionnistes">Réceptionnistes</router-link>
              </div>
            </div>
          </section>
          <section @click="menus.menuOpen4 = !menus.menuOpen4" class="d-flex flex-row justify-content-between">
            <div>
              <font-awesome-icon v-if="!menus.menuOpen4" :icon="['fas', 'bars']"></font-awesome-icon>
              <font-awesome-icon v-if="menus.menuOpen4" :icon="['fas', 'times']"></font-awesome-icon>
            </div>
            <div>Agents</div>
            <div>20</div>
          </section>
        </article>
        <article class="mt-3">
          <router-link to="annonces" tag="section">
            <div>
              <font-awesome-icon size="4x" :icon="['fas', 'bullhorn']"></font-awesome-icon>
            </div>
          </router-link>
          <router-link to="annonces" tag="section" class="d-flex flex-row justify-content-between">
            <div>&nbsp;</div>
            <div>Annonces</div>
            <div>3</div>
          </router-link>
        </article>
        <article class="mt-3">
          <router-link to="avis-clients" tag="section">
            <div>
              <font-awesome-icon size="4x" :icon="['fas', 'gavel']"></font-awesome-icon>
            </div>
          </router-link>
          <router-link to="avis-clients" tag="section" class="d-flex flex-row justify-content-between">
            <div>&nbsp;</div>
            <div>Avis Client</div>
            <div>90</div>
          </router-link>
        </article>
        <article class="mt-3">
          <router-link to="categories-produits" tag="section">
            <div>
              <font-awesome-icon size="4x" :icon="['fas', 'clipboard-list']"></font-awesome-icon>
            </div>
          </router-link>
          <router-link to="categories-produits" tag="section" class="d-flex flex-row justify-content-between">
            <div>&nbsp;</div>
            <div>Catégories des Produits</div>
            <div>70</div>
          </router-link>
        </article>
        <article class="mt-3">
          <section>
            <div v-if="!menus.menuOpen8">
              <font-awesome-icon size="4x" :icon="['fas', 'truck']"></font-awesome-icon>
            </div>
            <div v-if="menus.menuOpen8">
              <div>
                <font-awesome-icon :icon="['fas', 'ban']"></font-awesome-icon>
                <router-link to="commandes-annulees">Commandes annulées</router-link>
              </div>
              <div>
                <font-awesome-icon :icon="['fas', 'spinner']"></font-awesome-icon>
                <router-link to="commandes-encours">Commandes encours</router-link>
              </div>
              <div>
                <font-awesome-icon :icon="['fas', 'box-open']"></font-awesome-icon>
                <router-link to="commandes-livraison">Commandes livrées</router-link>
              </div>
              <div>
                <font-awesome-icon :icon="['fas', 'undo']"></font-awesome-icon>
                <router-link to="commandes-retournees">Commandes retournées</router-link>
              </div>
              <div>
                <font-awesome-icon :icon="['fas', 'check']"></font-awesome-icon>
                <router-link to="commandes-validees">Commandes validées</router-link>
              </div>
            </div>
          </section>
          <section @click="menus.menuOpen8 = !menus.menuOpen8" class="d-flex flex-row justify-content-between">
            <div>
              <font-awesome-icon v-if="!menus.menuOpen8" :icon="['fas', 'bars']"></font-awesome-icon>
              <font-awesome-icon v-if="menus.menuOpen8" :icon="['fas', 'times']"></font-awesome-icon>
            </div>
            <div>Commandes</div>
            <div>300</div>
          </section>
        </article>
        <article class="mt-3">
          <router-link to="faq" tag="section">
            <div>
              <font-awesome-icon size="4x" :icon="['fas', 'question-circle']"></font-awesome-icon>
            </div>
          </router-link>
          <router-link to="faq" tag="section" class="d-flex flex-row justify-content-between">
            <div>&nbsp;</div>
            <div>Faq</div>
            <div>50</div>
          </router-link>
        </article>
        <article class="mt-3">
          <section>
            <div v-if="!menus.menuOpen10">
              <font-awesome-icon size="4x" :icon="['fas', 'envelope']"></font-awesome-icon>
            </div>
            <div v-if="menus.menuOpen10">
              <div>
                <font-awesome-icon :icon="['fas', 'envelope-open-text']"></font-awesome-icon>
                <router-link to="message-mail">Mail</router-link>
              </div>
              <div>
                <font-awesome-icon :icon="['fas', 'file-signature']"></font-awesome-icon>
                <router-link to="message-contact">Contact</router-link>
              </div>
            </div>
          </section>
          <section @click="menus.menuOpen10 = !menus.menuOpen10" class="d-flex flex-row justify-content-between">
            <div>
              <font-awesome-icon v-if="!menus.menuOpen10" :icon="['fas', 'bars']"></font-awesome-icon>
              <font-awesome-icon v-if="menus.menuOpen10" :icon="['fas', 'times']"></font-awesome-icon>
            </div>
            <div>Messages</div>
            <div>99</div>
          </section>
        </article>
        <article class="mt-3">
          <section>
            <div v-if="!menus.menuOpen11">
              <font-awesome-icon size="4x" :icon="['fas', 'shopping-cart']"></font-awesome-icon>
            </div>
            <div v-if="menus.menuOpen11">
              <div>
                <font-awesome-icon :icon="['fas', 'spinner']"></font-awesome-icon>
                <router-link to="produits-encours">Produits disponible</router-link>
              </div>
              <div>
                <font-awesome-icon :icon="['fas', 'undo']"></font-awesome-icon>
                <router-link to="produits-collectes">Produits retournés</router-link>
              </div>
              <div>
                <font-awesome-icon :icon="['fas', 'ban']"></font-awesome-icon>
                <router-link to="produits-supprimes">Produits supprimés</router-link>
              </div>
              <div>
                <font-awesome-icon :icon="['fas', 'check']"></font-awesome-icon>
                <router-link to="produits-vendus">Produits vendus</router-link>
              </div>
            </div>
          </section>
          <section @click="menus.menuOpen11 = !menus.menuOpen11" class="d-flex flex-row justify-content-between">
            <div>
              <font-awesome-icon v-if="!menus.menuOpen11" :icon="['fas', 'bars']"></font-awesome-icon>
              <font-awesome-icon v-if="menus.menuOpen11" :icon="['fas', 'times']"></font-awesome-icon>
            </div>
            <div>Produits</div>
            <div>600</div>
          </section>
        </article>
        <article class="mt-3">
          <router-link to="promotions" tag="section">
            <div>
              <font-awesome-icon size="4x" :icon="['fas', 'percentage']"></font-awesome-icon>
            </div>
          </router-link>
          <router-link to="promotions" tag="section" class="d-flex flex-row justify-content-between">
            <div>&nbsp;</div>
            <div>Promotions</div>
            <div>66</div>
          </router-link>
        </article>
        <article class="mt-3">
          <router-link to="remboursements" tag="section">
            <div>
              <font-awesome-icon size="4x" :icon="['fas', 'undo']"></font-awesome-icon>
            </div>
          </router-link>
          <router-link to="remboursements" tag="section" class="d-flex flex-row justify-content-between">
            <div>&nbsp;</div>
            <div>Remboursements</div>
            <div>0</div>
          </router-link>
        </article>
        <article class="mt-3">
          <router-link to="suggestions-annonces" tag="section">
            <div>
              <font-awesome-icon size="4x" :icon="['fas', 'volume-up']"></font-awesome-icon>
            </div>
          </router-link>
          <router-link to="suggestions-annonces" tag="section" class="d-flex flex-row justify-content-between">
            <div>&nbsp;</div>
            <div>Suggestions Annonces</div>
            <div>77</div>
          </router-link>
        </article>
        <article class="mt-3">
          <router-link to="super-utilisateurs" tag="section">
            <div>
              <font-awesome-icon size="4x" :icon="['fas', 'user-secret']"></font-awesome-icon>
            </div>
          </router-link>
          <router-link to="super-utilisateurs" tag="section" class="d-flex flex-row justify-content-between">
            <div>&nbsp;</div>
            <div>Super Utilisateurs</div>
            <div>12</div>
          </router-link>
        </article>
        <article class="mt-3">
          <router-link to="transactions" tag="section">
            <div>
              <font-awesome-icon size="4x" :icon="['fas', 'hand-holding-usd']"></font-awesome-icon>
            </div>
          </router-link>
          <router-link to="transactions" tag="section" class="d-flex flex-row justify-content-between">
            <div>&nbsp;</div>
            <div>Transactions</div>
            <div>142</div>
          </router-link>
        </article>
        <article class="mt-3">
          <router-link to="utilisateurs" tag="section">
            <div>
              <font-awesome-icon size="4x" :icon="['fas', 'users']"></font-awesome-icon>
            </div>
          </router-link>
          <router-link to="utilisateurs" tag="section" class="d-flex flex-row justify-content-between">
            <div>&nbsp;</div>
            <div>Utilisateurs</div>
            <div>80</div>
          </router-link>
        </article>
        <article class="mt-3">
          <router-link to="vendeurs" tag="section">
            <div>
              <font-awesome-icon size="4x" :icon="['fas', 'house-user']"></font-awesome-icon>
            </div>
          </router-link>
          <router-link to="vendeurs" tag="section" class="d-flex flex-row justify-content-between">
            <div>&nbsp;</div>
            <div>Vendeurs</div>
            <div>150</div>
          </router-link>
        </article>
      </nav>
    </section>
  </main>
</template>

<script>
export default {
  name: "Accueil",
  data () {
    return {
      menus : {
        menuOpen1: false,
        menuOpen2: false,
        menuOpen3: false,
        menuOpen4: false,
        menuOpen5: false,
        menuOpen6: false,
        menuOpen7: false,
        menuOpen8: false,
        menuOpen9: false,
        menuOpen10: false,
        menuOpen11: false,
        menuOpen12: false,
        menuOpen13: false,
        menuOpen14: false,
        menuOpen15: false,
        menuOpen16: false,
        menuOpen17: false,
        menuOpen18: false
      }
    }
  },
  components: {},
  methods: {},
  computed: {}
}
</script>

<style lang="scss" scoped>
main{
  margin-bottom: 1rem;
  & > h1{
    font-size: x-large;
    color: var(--color-curious-blue, rgba(34, 134, 195, 1));
  }
  & > section{
    border: 1px solid var(--color-light-gray, rgba(229, 222, 222, 1));
    padding: .5rem 1rem;
    & > h2{
      font-size: larger;
      color: var(--color-forest-green, rgba(40, 167, 69, 1));
    }
    & > p{
      margin-bottom: 0;
    }
    & > nav{
      & > article{
        background-color: var(--color-maya-blue, rgba(100, 181, 246, 1));
        color: var(--color-white, rgba(255, 255, 255, 1));
        border-radius: 1rem;
        width: 235px;
        & > section:nth-child(1), & > section:nth-child(2){
          border: 1px solid var(--color-maya-blue, rgba(100, 181, 246, 1));
        }
        & > section:nth-child(1){
          text-align: center;
          padding: 1.5rem;
          border-radius: 1rem;
          height: 125px;
          display: flex;
          flex-direction: row;
          justify-content: center;
          & > div{
            align-self: center;
            text-align: justify;
            font-size: .95rem;
            & > div{
              & > a{
                color: var(--color-white, rgba(255, 255, 255, 1));
              }
            }
          }
        }
        & > section:nth-child(1):hover, & > section:nth-child(2):hover{
          background-color: var(--color-white, rgba(255, 255, 255, 1));
          color: var(--color-maya-blue, rgba(100, 181, 246, 1));
          cursor: pointer;
          & > div{
            & > div{
              & > a{
                color: var(--color-maya-blue, rgba(100, 181, 246, 1));
              }
            }
          }
          & > div:nth-child(1){}
          & > div:nth-child(2){}
          & > div:nth-child(3){
            border-radius: 50%;
            font-size: small;
            padding: .3rem;
            background-color: var(--color-maya-blue, rgba(100, 181, 246, 1));
            color: var(--color-white, rgba(255, 255, 255, 1));
          }
        }
        & > section:nth-child(2){
          padding: .5rem .8rem;
          border-top: 1px solid var(--color-white, rgba(255, 255, 255, 1));
          border-bottom-left-radius: 1rem;
          border-bottom-right-radius: 1rem;
          & > div:nth-child(1){
            font-size: 1.2rem;
          }
          & > div:nth-child(2){}
          & > div:nth-child(3){
            border-radius: 50%;
            font-size: small;
            padding: .3rem;
            background-color: var(--color-white, rgba(255, 255, 255, 1));
            color: var(--color-curious-blue, rgba(34, 134, 195, 1));
          }
        }
      }
    }
  }
}

@media (min-width: 576px) {}

@media (min-width: 768px) {}

@media (min-width: 992px) {}
</style>



// WEBPACK FOOTER //
// src/components/Accueil.vue